
import * as TX from 'app/calcs/Accountant/Transactions/interfaces'
import { ILocal705PensionInputs } from 'app/calcs/customers/local705/interfaces'
import { CommonPensionCalculations } from 'app/calcs/pensions'
import { IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { cachedLocal705RunCalculations } from 'app/redux/Customers/Local705/actions'
import { IRetirementPerson, Profile } from 'app/redux/Profile/model'
import { makePaymentExtractor } from 'app/workbookDAOs/local705DAO'
import * as _ from 'lodash'
import * as moment from 'moment'

class Local705PensionCalculations extends CommonPensionCalculations<ILocal705PensionInputs> {

  private spouse: IRetirementPerson

  constructor(profile: Profile) {
    super(profile, 'Local 705')
  }

  getMonthlyPensionAmount(member: IRetirementPerson, vals: ILocal705PensionInputs, when: moment.Moment): Promise<IMonthlyPensionPayments> {
    const spouse = this.spouse
    return cachedLocal705RunCalculations({ member, spouse, vals })
      .then(makePaymentExtractor(vals, when))
      .then((baseAmount) => {
        const kind = vals.formOfPayment as SimplePensionFormOfPayment
        return this.calculateSimplePension(when, baseAmount, kind, false)
      })
  }

  getPension(): ILocal705PensionInputs {
    return this.profile.pension.local705
  }

  getPerson(): IRetirementPerson {
    return this.profile.getHeadOfHousehold()
  }

  getTimeLineTransactions(): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTimeLineTransactions()
  }

  getTransactions(when: moment.Moment, tolerance: TX.TransactionTolerance = 'month'): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTransactions(when, tolerance)
  }

  setSpouse(spouse: IRetirementPerson) {
    this.spouse = spouse
  }
}

export {
  Local705PensionCalculations
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local705/index.ts